import {IEnumListEntry} from "../definitions";
export const STUFF_CATEGORIES = {
    HIDDEN: "hidden",
    BUILDING: "building",
    PLANT: "plant",
    CREATURE: "creature",
    SPECIAL: "special",
    DECORE: "decore",
    LONG_DECORE: "long_decore"
};


export const STUFF_CATEGORIES_LIST:IEnumListEntry[] = [
    { id: STUFF_CATEGORIES.HIDDEN, label: "hidden" },
    { id: STUFF_CATEGORIES.BUILDING, label: "building" },
    { id: STUFF_CATEGORIES.PLANT, label: "plant" },
    { id: STUFF_CATEGORIES.CREATURE, label: "creature" },
    { id: STUFF_CATEGORIES.SPECIAL, label: "special" },
    { id: STUFF_CATEGORIES.DECORE, label: "decore" },
    { id: STUFF_CATEGORIES.LONG_DECORE, label: "long_decore" }
];


// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-stuff-categories.ts